import React from 'react'
import { useForm } from '@inertiajs/react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

interface CreatePaymentMethodSheetProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

interface PaymentMethodFormData {
  payment_method: {
    name: string
  }
}

function defaultFormData(): PaymentMethodFormData {
  return {
    payment_method: {
      name: '',
    },
  }
}

export function CreatePaymentMethodSheet({
  open,
  onOpenChange,
}: CreatePaymentMethodSheetProps) {
  const form = useForm<PaymentMethodFormData>(defaultFormData())

  function handleClose() {
    form.reset()
    onOpenChange(false)
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.post('/fundraising/payment_methods', {
      onSuccess: () => {
        form.reset()
        onOpenChange(false)
      },
    })
  }

  return (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent className="w-[420px] sm:max-w-[420px] overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Nouveau mode de paiement</SheetTitle>
          <SheetDescription>
            Ajoutez un nouveau mode de paiement au systeme.
          </SheetDescription>
        </SheetHeader>

        <form onSubmit={handleSubmit} className="space-y-4 p-4">
          {/* Name */}
          <div className="space-y-2">
            <Label htmlFor="pm_name">Nom *</Label>
            <Input
              id="pm_name"
              value={form.data.payment_method.name}
              onChange={(e) =>
                form.setData('payment_method', {
                  ...form.data.payment_method,
                  name: e.target.value,
                })
              }
              placeholder="Ex: Virement bancaire"
              required
            />
            {/* CreatePaymentMethod merges model errors as flat attribute keys.
                A duplicate name collides on the generated `code` slug (code
                uniqueness), so surface both keys, not just `name`. */}
            {(form.errors['name'] || form.errors['code']) && (
              <p className="text-sm text-destructive">
                {form.errors['name'] || form.errors['code']}
              </p>
            )}
          </div>

          <div className="flex gap-3 pt-2">
            <Button type="submit" disabled={form.processing} className="flex-1">
              {form.processing ? 'Creation...' : 'Creer'}
            </Button>
            <Button type="button" variant="outline" onClick={handleClose}>
              Annuler
            </Button>
          </div>
        </form>
      </SheetContent>
    </Sheet>
  )
}
